'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoLocalizacaoCtrl', function ($rootScope, $scope, $log, URL, $timeout, uiGmapGoogleMapApi, $location, $stateParams, $interval, Historico) {
        // classe para animação da view
        $scope.pageClass = 'page-localizacao';

        // timer de atualizacao do mapa
        $scope.timer = null;

        $scope.atualizaCoordenadas = function () {
            Historico.coordinates($stateParams.idPedido)
                .then(function (data) {
                    // atualiza as coordenadas do mapa e colaborador
                    $scope.marker.coords = {
                        latitude: data.latitude,
                        longitude: data.longitude
                    };
                    $scope.map.control.refresh({
                        latitude: data.latitude,
                        longitude: data.longitude
                    });
                })
                .catch($scope.tratarErrosBackEnd);
        };

        Historico.getSituacaoOs($stateParams.idPedido)
            .then(function (pedido) {
                $scope.pedido = pedido;
            })
            .catch($scope.tratarErrosBackEnd);

        uiGmapGoogleMapApi.then(function (maps) {
            $scope.initMaps = function (id, latitude, longitude) {
                // config do mapa
                $scope.zoom = 17;
                // habilita ou desabilita scroll
                $scope.options = {
                    scrollwheel: true
                };
                // config do icone do colaborador
                $scope.marker = {
                    id: id,
                    coords: {
                        latitude: latitude,
                        longitude: longitude
                    },
                    options: {
                        draggable: false
                    },
                    icon: {
                        url: '/assets/images/pin.png'
                    }
                };
                // config do mapa
                $scope.map = {
                    center: {
                        latitude: latitude,
                        longitude: longitude
                    },
                    zoom: $scope.zoom,
                    icon: $scope.marker.icon,
                    control: {}
                };
            };

            Historico.coordinates($stateParams.idPedido)
                .then(function (data) {
                    // inicia o mapa
                    $scope.initMaps(data.id, data.latitude, data.longitude);

                    // cria timer de atualizacao do mapa
                    $scope.timer = $interval($scope.atualizaCoordenadas, 30000);
                })
                .catch($scope.tratarErrosBackEnd);
        });

        // destroi timer de atualizacao do mapa
        $scope.$on('$destroy', function () {
            if ($scope.timer) {
                $interval.cancel($scope.timer);
            }
        });

    });